import type { SwitchProps as SwitchPropsBase } from "react-native"

import React from "react"
import { Switch as SwitchBase } from "react-native"

import { useCurrentColorMode, useIsDarkMode } from "./AppThemeContextProvider"
import { testIds } from "./test-id"
import { COLORS } from "./theme/colors"

import type { TestId } from "./test-id"

import { useStyle } from "react-native-style-utilities"

const SIZES = {
  large: 1,
  medium: 0.9,
  small: 0.8,
}

export interface SwitchProps extends Omit<SwitchPropsBase, "disabled" | "id"> {
  id?: TestId
  isDisabled?: boolean
  size?: keyof typeof SIZES
}
export function Switch({
  id = "toggleSwitch",
  isDisabled,
  size = "medium",
  style,
  ...rest
}: SwitchProps) {
  const mode = useCurrentColorMode()
  const isDarkMode = useIsDarkMode()
  const trackColor = {
    false: COLORS.$gray[isDarkMode ? 600 : 300],
    true: COLORS.$buttonPrimary[mode],
  }
  return (
    <SwitchBase
      // @ts-expect-error - this prop is web-only; RN types don't recognize it
      activeThumbColor={isDarkMode ? COLORS.$gray[200] : COLORS.$white}
      disabled={isDisabled}
      role={"switch"}
      thumbColor={COLORS.$gray[100]}
      trackColor={trackColor}
      style={useStyle(() => {
        const scale = SIZES[size]
        return [
          style,
          {
            transform: [{ scaleX: scale }, { scaleY: scale }],
          },
        ]
      }, [size, style])}
      {...testIds(id)}
      {...rest}
    />
  )
}
